/**
 * Created with IntelliJ IDEA.
 * User: itaik
 * Date: 2/13/13
 * Time: 2:59 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Logger = require("logger");
    var $ = require("jquery");
    var _ = require("underscore");
    var Backbone = require("backbone");
    var ChildViewContainer = require("backbone.babysitter");
    var Marionette = require("marionette");

    var ComponentManager = (function () {

        return {
            getHost:function (options) {
                var logger = Logger.getLogger("ComponentManagerHost");
                var ids = {};
                var components = new ChildViewContainer();
                var valueReaders = {};
                var eventListeners = {};
                var isDirty = false;
                var jsonValues = null;

                options = options || {};
                var vent = options.vent;
                var parentView = options.view;

                if (_.isUndefined(vent) && !_.isUndefined(parentView) && !_.isUndefined(parentView.vent)) {
                    vent = parentView.vent;
                }

                return {
                    getLength:function () {
                        return components.length;
                    },
                    getComponent:function (id) {
                        return components.findByCustom(id);
                    },
                    getComponents:function() {
                        return components;
                    },
                    hasComponent:function (id) {
                        return (_.isString(id) && !_.isUndefined(ids[id]) && !_.isUndefined(this.getComponent(id)));
                    },
                    restartChangesTracking:function () {
                        isDirty = false;
                        jsonValues = this.toJSON();
                    },
                    hasChanges:function () {
                        if (isDirty) {
                            return true;
                        } else {
                            var json = this.toJSON();
                            if (_.isObject(jsonValues)) {
                                var changes = false;
                                _.each(json, function (value, key) {
                                    if (!_.isEqual(value, jsonValues[key])) {
                                        changes = true;
                                        return;
                                    }
                                });

                                isDirty = changes;
                            }

                            return isDirty;
                        }
                    },
                    registerComponentEvents:function (id, events) {
                        if (!this.hasComponent(id)) {
                            logger.error("error in registerComponentEvent.","componentManager:registerComponentEvents");
                            logger.error("A component with id '" + id + "' does not exist","componentManager:registerComponentEvents");
                            logger.graph({ name: "UIComponents:componentManager:registerComponentEvents:error"});
                            return null;
                        } else {
                            if (!_.isObject(events)) {
                                logger.error("error in registerComponentEvents.. with id:" +id,"componentManager:registerComponentEvents");
                                logger.error("A valid listener with id eventName and handler expected","componentManager:registerComponentEvents",{ events: events });
                                logger.graph({ name: "UIComponents:componentManager:registerComponentEvents:error"});
                                return null;
                            } else {
                                var component = this.getComponent(id);
                                eventListeners[id] = eventListeners[id] || {};
                                var that = this;
                                _.each(events, function (handler, eventName) {
                                    if (!_.isString(eventName) || (!_.isString(handler) && !_.isFunction(handler) && !_.isObject(handler) && !_.isUndefined(handler))) {
                                        that.logger.error("error in registerComponentListener.. with id:" +id,"componentManager:registerComponentEvents");
                                        that.logger.error("A valid listener with eventName and handler expected","componentManager:registerComponentEvents",{handler: handler, eventName: eventName});
                                        that.logger.graph({ name: "UIComponents:componentManager:registerComponentEvents:error"});
                                    } else {
                                        var handlerWrapper = function () {
                                            var eventArgs = [].slice.apply(arguments);
                                            eventArgs.unshift(eventName);
                                            eventArgs.unshift(id);

                                            // First check if the handler is a string
                                            if (_.isString(handler)) {
                                                // When the handler is a string we should check if we have a parent view and if
                                                // This view implements a method with that name
                                                if (!_.isUndefined(parentView) && parentView instanceof Marionette.View && _.isFunction(parentView[handler])) {
                                                    // Invoke the handler on the parent view
                                                    parentView[handler].apply(parentView, eventArgs);
                                                } else if (!_.isUndefined(vent)) {
                                                    // The handler string probably represents an event that should be triggered on the vent
                                                    // Raise event on the vent
                                                    vent.trigger(handler, eventArgs);
                                                } else if (!_.isUndefined(parentView) && parentView instanceof Marionette.View) {
                                                    // The handler string probably represents an event that should be triggered on the parent view itself
                                                    // Raise event on the vent
                                                    parentView.trigger(handler, eventArgs);
                                                }
                                            } else if (_.isFunction(handler)) {
                                                // We only have a function reference so we'll invoke it with a null context
                                                handler.apply(null, eventArgs);
                                            } else if (_.isObject(handler) && !_.isUndefined(handler) && _.isFunction(handler.callback)) {
                                                // We have a function reference and we may have a context so we'll invoke it with a context
                                                handler.callback.apply(handler.context, eventArgs);
                                            }
                                        };

                                        eventListeners[id][eventName] = handlerWrapper;
                                        component.on(eventName, handlerWrapper);
                                    }
                                });
                            }
                        }
                    },
                    unregisterComponentEvents:function (id, events) {
                        if (!this.hasComponent(id)) {
                            logger.error("error in unregisterComponentEvents.","componentManager:UnRegisterComponentEvents");
                            logger.error("A component with id '" + id + "' does not exist","componentManager:UnRegisterComponentEvents");
                            logger.graph({ name: "UIComponents:componentManager:unregisterComponentEvents:error"});
                            return null;
                        } else {
                            var component = this.getComponent(id);
                            if (_.isObject(eventListeners[id])) {
                                if (_.isUndefined(events)) {
                                    _.each(eventListeners[id], function (handler, eventName) {
                                        component.off(eventName, handler);
                                        delete eventListeners[id][eventName];
                                    });
                                } else {
                                    var eventsArr = events;
                                    if (!_.isArray(events)) {
                                        eventsArr = [events];
                                    }

                                    _.each(eventsArr, function (eventName) {
                                        if (_.isString(eventName) && !_.isUndefined(eventListeners[id][eventName])) {
                                            component.off(eventName, eventListeners[id][eventName]);
                                            delete eventListeners[id][eventName];
                                        }
                                    });
                                }
                            }
                        }
                    },
                    createComponent:function (id, options) {
                        // TODO: Think about the document events
                        var ComponentType = options.type;
                        var componentValueReadMethodName = options.valueReadMethodName;
                        var componentOptions = options.options;
                        var componentEvents = options.events;

                        if (this.hasComponent(id)) {
                            logger.error("error in createComponent. with id:" +id,"componentManager:createComponent");
                            logger.error("A component with id '" + id + "' already exists","componentManager:createComponent");
                            logger.graph({ name: "UIComponents:componentManager:createComponent:error"});
                            return null;
                        } else if (_.isUndefined(ComponentType)) {
                            logger.error("error in createComponent. with id:" +id,"componentManager:createComponent");
                            logger.error("No type supplied for the component","componentManager:createComponent");
                            logger.graph({ name: "UIComponents:componentManager:createComponent:error"});
                            return null;
                        } else {
                            var ops = $.extend(true, {}, componentOptions);
                            if (!_.isUndefined(parentView) && parentView instanceof Marionette.View) {
                                if (_.isFunction(componentOptions)) {
                                    componentOptions = componentOptions.call(parentView);
                                    ops = $.extend(true, {}, componentOptions);
                                } else if (_.isString(componentOptions) && !_.isUndefined(parentView[componentOptions])) {
                                    componentOptions = _.result(parentView, componentOptions);
                                    ops = $.extend(true, {}, componentOptions);
                                }

                                if (!_.isUndefined(componentOptions)) {
                                    // Check if a view specific method or attribute is used for initialization of the component
                                    _.each(componentOptions, function (value, key) {
                                        var option;
                                        var obj;

                                        if (_.isString(value) && 0 === value.indexOf("view.") && !_.isUndefined(parentView)) {
                                            var path = value.replace(/^view./, "");
                                            var parts = path.split(".");

                                            obj = parentView;
                                            option = parts[parts.length - 1];
                                            parts.pop();

                                            while (!_.isUndefined(obj) && 0 < parts.length) {
                                                obj = _.result(obj, parts[0]);
                                                parts.shift();
                                            }
                                        }

                                        var result = ((_.isString(option) && !_.isUndefined(obj)) ? _.result(obj, option) : option);
                                        if (!_.isUndefined(option)) {
                                            ops[key] = result;
                                        }
                                    });
                                }
                            }
                            var componentInstance = new ComponentType(ops);
                            if (!(componentInstance instanceof Backbone.View)) {
                                logger.error("error in createComponent.. with id:" +id,"componentManager:createComponent");
                                logger.error("expected component type of type Backbone.View, got: " + typeof componentInstance,"componentManager:createComponent");
                                logger.graph({ name: "UIComponents:componentManager:createComponent:error"});
                                return null;
                            } else {
                                ids[id] = componentInstance.cid;

                                // Handle close of the component - we would like to remove it when it is closed
                                var closeWrapper = function () {
                                    this.removeComponent(id);
                                };
                                componentInstance.once("close", _.bind(closeWrapper, this));

                                components.add(componentInstance, id);

                                if (_.isString(componentValueReadMethodName) && _.isFunction(componentInstance[componentValueReadMethodName]) || _.isFunction(componentValueReadMethodName)) {
                                    valueReaders[id] = componentValueReadMethodName;
                                }


                                if (_.isFunction(componentEvents)) {
                                    componentEvents = componentEvents.call(parentView);
                                    ops = $.extend(true, {}, componentEvents);
                                } else if (_.isString(componentEvents) && !_.isUndefined(parentView[componentEvents])) {
                                    componentEvents = _.result(parentView, componentEvents);
                                    ops = $.extend(true, {}, componentEvents);
                                }

                                if (!_.isUndefined(componentEvents)) {
                                    this.registerComponentEvents(id, componentEvents);
                                }

                                return componentInstance;
                            }
                        }
                    },
                    createComponents:function (comps) {
                        var items = {};

                        _.each(comps, function (item, key) {
                            var id = item.id;
                            var comp = item;

                            if (_.isUndefined(id)) {
                                // We are iterating over an object (and not an array) and "key" represents the id
                                id = key;
                            }

                            if (!_.isUndefined(id) && !_.isUndefined(comp)) {
                                var created = this.createComponent(id, comp);

                                if (created) {
                                    items[id] = created;
                                }
                            }
                        }, this);

                        return items;
                    },
                    removeComponent:function (id) {
                        var component;

                        if (this.hasComponent(id)) {
                            component = this.getComponent(id);
                            this.unregisterComponentEvents(id);
                            components.remove(component);
                            delete valueReaders[id];
                            delete ids[id];
                        }

                        return component;
                    },
                    removeAllComponents:function () {
                        var comps = {};
                        _.each(ids, function (cid, id) {
                            comps[id] = this.removeComponent(id);
                        }, this);

                        return comps;
                    },
                    toJSON:function () {
                        var json = {};

                        if (0 < components.length) {
                            var that = this;
                            _.each(valueReaders, function (readMethod, id) {
                                if (that.hasComponent(id)) {
                                    var val;
                                    var component = that.getComponent(id);

                                    if (_.isFunction(component[readMethod])) {
                                        val = _.bind(component[readMethod], component);
                                    } else if (_.isFunction(readMethod)) {
                                        val = _.bind(readMethod, component);
                                    }
                                    json[id] = val;
                                }
                            });
                        }

                        return json;
                    },
                    toJSONChanges:function () {
                        var json = this.toJSON();
                        var changes = {};
                        if (_.isObject(jsonValues)) {
                            _.each(json, function (value, key) {
                                if (!_.isEqual(value, jsonValues[key])) {
                                    changes[key] = value;
                                }
                            });
                        }

                        return changes;
                    },
                    callAllComponents:function (method) {
                        components.call(method, _.tail(arguments));
                    },
                    applyAllComponents:function (method, args) {
                        components.apply(method, args || []);
                    },
                    renderAllComponents:function () {
                        this.callAllComponents("render");
                        setTimeout(_.bind(this.restartChangesTracking, this), 0);
                    },
                    closeAllComponents:function () {
                        this.callAllComponents("close");
                    },
                    show:function (id) {
                        var comp = this.getComponent(id);

                        if (!_.isUndefined(comp)) {
                            comp.$el.show.apply(comp.$el, _.tail(arguments));
                        }
                    },
                    hide:function (id) {
                        var comp = this.getComponent(id);

                        if (!_.isUndefined(comp)) {
                            comp.$el.hide.apply(comp.$el, _.tail(arguments));
                        }
                    },
                    showAll:function () {
                        var args = [].slice.apply(arguments);
                        _.each(ids, function (cid, id) {
                            args.unshift(id);
                            this.show.apply(this, args);
                            args.shift();
                        }, this);
                    },
                    hideAll:function () {
                        var args = [].slice.apply(arguments);
                        _.each(ids, function (cid, id) {
                            args.unshift(id);
                            this.hide.apply(this, args);
                            args.shift();
                        }, this);
                    }
                };
            }
        };
    }());

    return ComponentManager;
});
